import { productAxiosInstance } from "@/services/axios";

export interface StorefrontMenu {
  id: number;
  name: string;
  product_count?: number;
}

export function uniqueMenus(menus: StorefrontMenu[]): StorefrontMenu[] {
  const seen = new Set<number>();
  return menus.filter((menu) => {
    if (!menu || !menu.id || seen.has(menu.id)) return false;
    seen.add(menu.id);
    return true;
  });
}

export const getMenu = async (
  {
    page = 1,
    vendor_id,
  }: {
    page?: number;
    vendor_id: string;
  } = {} as { vendor_id: string; page?: number },
) => {
  const response = await productAxiosInstance.get("/menu/", {
    params: { page, vendor_id },
  });
  return response.data;
};
